import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Types
export type IFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
};

// Utilities
import {
  required,
  email,
  name,
  mobile,
  between
} from '../../utilities/validation';

// Form
class DetailsFormState {
  // Create a field
  firstName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  lastName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  email = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 100), email);
  mobile = new FieldState('')
    .disableAutoValidation()
    .validators(required, mobile);

  // Compose fields into a form
  state = new FormState({
    firstName: this.firstName,
    lastName: this.lastName,
    email: this.email,
    mobile: this.mobile
  });

  getValues() {
    return {
      firstName: this.firstName.$,
      lastName: this.lastName.$,
      email: this.email.$,
      mobile: this.mobile.$
    };
  }

  initValues(values: IFormValues) {
    this.firstName.reinitValue(values.firstName);
    this.lastName.reinitValue(values.lastName);
    this.email.reinitValue(values.email);
    this.mobile.reinitValue(values.mobile);
  }

  reset() {
    this.firstName.reinitValue('');
    this.lastName.reinitValue('');
    this.email.reinitValue('');
    this.mobile.reinitValue('');
  }
}

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import Grid from '../../components/Grid';
import { Form, TextField } from '../../components/FormStateFields';

// Component
interface IProps {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
  };
  onSubmit: (values: IFormValues) => void;
}

class DetailsTab extends React.Component<IProps, {}> {
  form = new DetailsFormState();

  componentWillMount() {
    this.form.initValues(this.props.user);
  }

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validation = await this.form.state.validate();

    if (validation.hasError === false) {
      this.props.onSubmit({ ...this.props.user, ...this.form.getValues() });
    }
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Box pa={4}>
          <Grid container={true}>
            <Grid item={true} xs={6}>
              <TextField
                label="First Name"
                type="text"
                required={true}
                fieldState={this.form.firstName}
                margin="normal"
                fullWidth={true}
              />
            </Grid>
            <Grid item={true} xs={6}>
              <TextField
                label="Last Name"
                type="text"
                required={true}
                fieldState={this.form.lastName}
                margin="normal"
                fullWidth={true}
              />
            </Grid>
          </Grid>
          <Grid container={true}>
            <Grid item={true} xs={6}>
              <TextField
                label="Email"
                type="text"
                required={true}
                fieldState={this.form.email}
                margin="normal"
                fullWidth={true}
              />
            </Grid>
            <Grid item={true} xs={6}>
              <TextField
                label="Mobile No."
                type="text"
                required={true}
                fieldState={this.form.mobile}
                margin="normal"
                fullWidth={true}
              />
            </Grid>
          </Grid>
          <br />
          <Button
            raised={true}
            color="primary"
            style={{ width: '100%' }}
            type="submit"
          >
            Save
          </Button>
        </Box>
      </Form>
    );
  }
}

export default observer(DetailsTab);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/MeDialogDetails.tsx